/**
 * README.md
 *
 * If you add to this enum, keep Alphabetical Order!
 * If list is out of order, use the following vscode command:
 * `cmd+shift+p > 'Sort Lines Ascending'`
 */
export enum Icons {
  Account = 'circle-user-round',
  Activity = 'activity',
  Add = 'plus',
  AddCircle = 'circle-plus',
  Ai = 'sparkles',
  Archive = 'archive',
  ArrowBack = 'arrow-left',
  ArrowDownward = 'arrow-down',
  ArrowForward = 'play',
  ArrowRight = 'chevron-right',
  ArrowRightAlt = 'arrow-right',
  ArrowUp = 'circle-arrow-up',
  ArrowUpward = 'arrow-up',
  Article = 'file-text',
  Assessment = 'chart-column',
  AssessRisk = 'ruler',
  Assignment = 'clipboard-list',
  Back = 'arrow-left',
  Bolt = 'zap',
  Book2 = 'book-open',
  Calendar = 'calendar-days',
  Car = 'car',
  CenterFocusWeak = 'scan',
  Chat = 'message-circle',
  Check = 'check',
  Checklist = 'list-checks',
  Checkmark = 'circle-check',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  Close = 'x',
  CloudDownload = 'cloud-download',
  CollapseNav = 'panel-left-close',
  Comlog = 'message-square-text',
  Computer = 'monitor',
  Construction = 'wrench',
  CostJustify = 'dollar-sign',
  DarkMode = 'moon',
  Dashboard = 'layout-grid',
  DollarSign = 'dollar-sign',
  Delete = 'trash-2',
  Description = 'file-text',
  Desk = 'lamp-desk',
  Domain = 'building-2',
  Done = 'check',
  DoneAll = 'check-check',
  Download = 'download',
  Draft = 'file',
  DragIndicator = 'grip-vertical',
  DropDown = 'chevron-down',
  EarlyIntervention = 'shield-user',
  EcgHeart = 'heart-pulse',
  Edit = 'pencil',
  Education = 'graduation-cap',
  Email = 'mail',
  Enterprise = 'building',
  Equal = 'equal',
  Ergonomics = 'factory',
  Error = 'circle-alert',
  ExpandNav = 'panel-left-open',
  Explore = 'compass',
  FastForward = 'fast-forward',
  FastRewind = 'rewind',
  File = 'paperclip',
  FileDownload = 'download',
  Filter = 'funnel',
  Flag = 'flag',
  Folder = 'folder',
  Fold = 'chevrons-down-up',
  FormatListNumbered = 'list-ordered',
  Forward = 'arrow-right',
  FullBody = 'person-standing',
  Groups = 'users',
  GroupTraining = 'graduation-cap',
  HazardFlag = 'flag',
  HealthAndSafety = 'shield-plus',
  Help = 'circle-question-mark',
  History = 'history',
  ImprovementOpportunityFlag = 'wrench',
  ImprovementProject = 'flame',
  Info = 'info',
  Intercom = 'messages-square',
  IsmDashboard = 'heart-pulse',
  JobRotation = 'rotate-ccw',
  KeyboardArrowDown = 'chevron-down',
  KeyboardArrowLeft = 'chevron-left',
  KeyboardArrowRight = 'chevron-right',
  KeyboardDoubleArrowDown = 'chevrons-down',
  Language = 'globe',
  LightMode = 'sun',
  ListChecks = 'list-checks',
  Lock = 'lock',
  Logout = 'log-out',
  Map = 'map',
  MapPin = 'map-pin',
  Menu = 'menu',
  MenuBook = 'book-open',
  ModelTraining = 'brain-cog',
  Monitor = 'monitor',
  MoreHoriz = 'ellipsis',
  MoreVert = 'ellipsis-vertical',
  News = 'newspaper',
  Note = 'notebook-pen',
  Notifications = 'bell',
  NotVisible = 'eye-off',
  OpenInNew = 'external-link',
  PDF = 'file-down',
  People = 'users',
  PeopleRound = 'users-round',
  Percent = 'percent',
  Person = 'user-round',
  PersonCheck = 'user-round-check',
  PersonSearch = 'user-search',
  PieChart = 'chart-pie',
  PlayCircle = 'circle-play',
  Print = 'printer',
  Prioritize = 'list-video',
  Priority = 'arrow-up-down',
  Public = 'globe',
  RadioButtonUnchecked = 'circle',
  Redo = 'redo-2',
  Refresh = 'refresh-cw',
  Remove = 'minus',
  RootCauseFlag = 'search',
  Schedule = 'clock',
  Search = 'search',
  Settings = 'settings',
  Settings2 = 'settings-2',
  ShieldBad = 'shield-x',
  ShieldCheck = 'shield-check',
  ShieldExclamation = 'shield-alert',
  ShieldOff = 'shield-off',
  Spotlight = 'lightbulb',
  Sparkles = 'sparkles',
  Star = 'star',
  Stretching = 'person-standing',
  Subtasks = 'corner-down-right',
  Support = 'life-buoy',
  SwapHoriz = 'arrow-left-right',
  TakePhoto = 'camera',
  Target = 'target',
  Task = 'file-check',
  TrackChanges = 'crosshair',
  TrendingDown = 'trending-down',
  TrendingUp = 'trending-up',
  TaskProgressStepperIconComplete = 'check',
  TaskProgressStepperIconIncomplete = 'circle-alert',
  TaskStep = 'circle',
  ThumbUp = 'thumbs-up',
  Timeline = 'activity',
  Topic = 'folder',
  Trophy = 'trophy',
  Undo = 'undo-2',
  Unfold = 'chevrons-up-down',
  Upload = 'cloud-upload',
  Videocam = 'video',
  Visible = 'eye',
  VitalSigns = 'activity',
  Warning = 'triangle-alert',
  Work = 'briefcase',
}
